const MediaSize = {
    small: "600px",
    medium: "900px",
    large: "1200px",
}

export default MediaSize;